import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Icon } from '../../atoms';
import styles from './Modal.module.css';
export const Modal = ({ isOpen, onClose, title, size = 'medium', closeOnOverlayClick = true, closeOnEsc = true, showCloseButton = true, children, className = '', ...props }) => {
    const modalRef = useRef(null);
    // Handle ESC key press
    useEffect(() => {
        if (!isOpen || !closeOnEsc)
            return;
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, closeOnEsc, onClose]);
    // Lock body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    // Focus trap
    useEffect(() => {
        if (!isOpen)
            return;
        const focusableElements = modalRef.current?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!focusableElements || focusableElements.length === 0)
            return;
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const handleTab = (event) => {
            if (event.key !== 'Tab')
                return;
            if (event.shiftKey) {
                if (document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                }
            }
            else {
                if (document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        };
        document.addEventListener('keydown', handleTab);
        firstElement.focus();
        return () => document.removeEventListener('keydown', handleTab);
    }, [isOpen]);
    const handleOverlayClick = (event) => {
        if (closeOnOverlayClick && event.target === event.currentTarget) {
            onClose();
        }
    };
    if (!isOpen)
        return null;
    const modalClasses = [styles.modal, styles[size], className]
        .filter(Boolean)
        .join(' ');
    return (_jsx("div", { className: styles.overlay, onClick: handleOverlayClick, role: "dialog", "aria-modal": "true", children: _jsxs("div", { ref: modalRef, className: modalClasses, ...props, children: [(title || showCloseButton) && (_jsxs("div", { className: styles.header, children: [title && _jsx("h2", { className: styles.title, children: title }), showCloseButton && (_jsx("button", { type: "button", onClick: onClose, className: styles.closeButton, "aria-label": "Close modal", children: _jsx(Icon, { name: "x", size: "sm" }) }))] })), _jsx("div", { className: styles.content, children: children })] }) }));
};
